import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Box, Button, IconButton, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { SolicitedUsersProps } from "./types"
import { NotSolicitedUsers } from "../noSolicitedUsers"
import { icons } from "../../../../../../utils/icons"
import { useState } from "react"


export const SolicitedUsers = ({ isEdit, solictedUser, deleteUser, handleShowTable }: SolicitedUsersProps) => {


    const { t } = useTranslation()
    const styles = useStyles()
    const [seeMore, setSeeMore] = useState(false)
    const showButton = solictedUser.length > 2


    return (
        <Box sx={[styles.flex1, styles.mainCotainer]}>
            <Typography variant="title_grey" fontSize={16}>{t('filesManager.titles.solicitedUsers')}</Typography>

            <CustomPaper elevation={3} sx={styles.container}>
                {!solictedUser.length ?
                    <NotSolicitedUsers title={t('filesManager.titles.usersWithoutSelect')} />
                    :
                    <>
                        {isEdit ?
                            <Box sx={styles.boxUser(showButton, seeMore, isEdit)}>
                                {solictedUser.map(user => (
                                    <Box key={user.id} sx={[styles.userContainer, styles.userBox]}>
                                        {icons('personFilled')}
                                        <Typography sx={styles.userName}>{user.name}</Typography>
                                        <IconButton onClick={() => { if (deleteUser) { deleteUser(user.id) } }} sx={styles.buttonClose}>{icons('simple-close')}</IconButton>
                                    </Box>
                                ))}
                            </Box>
                            :
                            <Box sx={styles.boxUser(showButton, seeMore, isEdit)}>
                                {solictedUser.map(user => (
                                    <CustomPaper elevation={2} key={user.id} sx={styles.userContainer}>
                                        {icons('personFilled')}
                                        <Typography sx={styles.userName}>{user.name}</Typography>
                                    </CustomPaper>
                                ))}
                            </Box>
                        }
                    </>
                }

                {isEdit &&
                    <Box sx={{paddingTop:1}}>
                        <IconButton onClick={()=>{handleShowTable(true)}} sx={styles.addButton}>{icons('add')}</IconButton>
                    </Box>
                }
            </CustomPaper>

            {showButton &&
                <Box sx={styles.containerButton}>
                    <Button sx={styles.buton} onClick={() => { setSeeMore(prev => !prev) }}>{!seeMore ? t('loogbook.buttons.seeMore') : t('loogbook.buttons.seeLess')} {!seeMore ? icons('view-more') : icons('view-less')}</Button>
                </Box>
            }
        </Box>
    )
}